import React, { Component, useEffect, useState } from "react";
import ComponentDonationDetailMobile from "./ComponentDonationDetailMobile";
import ComponentDonationDetailWeb from "./ComponentDonationDetailWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentDonationDetail = () => {
  const gaEventTracker = useAnalyticsEventTracker("DonationDetail");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Donation Detail",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentDonationDetailWeb></ComponentDonationDetailWeb>
      </BrowserView>
      <MobileView>
        <ComponentDonationDetailMobile></ComponentDonationDetailMobile>
      </MobileView>
    </>
  );
};

export default ComponentDonationDetail;
